
export const AUTH_TOKEN = 'auth-token';


export const getCookies = () => (
  Object.fromEntries(document.cookie.split(';')
  .map(cookie => cookie.trim()).filter(cookie => cookie.trim())
  .map(cookie => cookie.split('=')))
);


export const setCookie = cookieData => {
  if (!('expires' in cookieData)) {
    const date = new Date();
    date.setDate(date.getDate() + 30);
    cookieData.expires = date.toUTCString();
  }
  if (!('path' in cookieData)) {
    cookieData.path = '/';
  }
  document.cookie = (
    Object.entries(cookieData).map(([key, value]) => `${key}=${value}`).join('; ')
  );
};


export const saveToken = token => {
  if (token !== null) {
    setCookie({ [AUTH_TOKEN]: token });
  }
};


export const getToken = () => {
  return getCookies()[AUTH_TOKEN] || null;
};


export const deleteToken = () => {
  const cookies = getCookies();
  if (AUTH_TOKEN in cookies) {
    setCookie({ [AUTH_TOKEN]: '', expires: 'Thu, 01 Jan 1970 00:00:01 GMT' });
  }
};

export const getBackendUrl = path => {
  if (process.env.NODE_ENV === 'production') {
    return path;
  }
  return `http://localhost:8000${path}`;
};